import React, { use, useEffect, useRef, useState } from "react";
import { Modal, Box, Typography, IconButton, Button, Radio, FormControlLabel, RadioGroup, Snackbar, Rating, TextField } from "@mui/material";

import moment from "moment";
import PhoneRingIcon from '../Images/PhoneRing.svg';
import MapplsMap from "../Component/MapplsMap";
import { addReview, generateMapToken, getRoute, getService, addIssueReport } from "../Network/APIService";
import { Mqtt } from "../Network/mqtt";
import WhiteLinePhone from '../Images/WhiteLinePhone.svg';
import RadioImage from '../Images/Radio.svg';
import StarGray from '../Images/StarGray.svg';
import StarOrange from '../Images/StarOrange.svg';
import Close from '../Images/Close.svg';
import { useParams } from 'react-router-dom';
import { Location, ServiceRequest } from "../model";
import { useSearchParams } from 'react-router-dom';
import TimeIntervalLabel from "../Component/TimeIntervalLable";


const reportPopupStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -45%)',
  width: '70%',
  bgcolor: 'background.paper',
  border: '2px solid #ffffffff',
  boxShadow: 24,
  p: 3
};

const EndUserStatusScreen: React.FC = () => {

  const [mapToken, setMapToken] = useState<string | null>();
  const [currentService, setCurrentService] = useState<ServiceRequest>()
  const [isError, setIsError] = useState(false)

  const [isReport, setIsReport] = useState(false);
  const [selectedOption, setSelectedOption] = useState("");

  const [rating, setRating] = React.useState<number | null>(0);
  const [review, setReview] = React.useState("");
  const [isRatings, setIsRatings] = useState(false);

  const [imageUrl, setImageUrl] = useState<string>();

  const [pathCoordinates, setPathCoordinates] = useState<Array<{ lat: number, lng: number }>>([]);
  const pathCoordinatesref = useRef(pathCoordinates);

  const [searchParams, setSearchParams] = useSearchParams();



  useEffect(() => {
    generateMapToken().then(token => {
      setMapToken(token);
    });

    getService().then(service => {
      if (service == null) {
        setIsError(true);

        setTimeout(() => {
          setIsError(false);
        }, 3000);

      }
      else {
        setCurrentService(service);


        Mqtt.connect().then(isConnected => {
          var status = service?.status == "accepted" ? "pickupStatus" : "deliveryStatus";
          var topic = `${process.env.REACT_APP_MQTT_TOPIC}/${status}/${service?._id}/${service?.deliveryPartner?._id}/location`
          Mqtt.subscribe(topic, onLocationUpdate)
        })
        getRoute(service.deliveryPartner._id).then(routeData => {
          //setRouteData(routeData);
          if (!routeData?.location)
            return;
          convertLocationToGeoRoute(routeData.location);

        });
      }
    });

    return () => {
      Mqtt.disconnect();
    }

  }, [])

  useEffect(() => {
    var token = searchParams.get("token");
    if (token)
      sessionStorage.setItem('authToken', token!);

  }, [searchParams])

  useEffect(() => {
    pathCoordinatesref.current = pathCoordinates;
  }, [pathCoordinates]);


  useEffect(() => {
    const fetchImage = async () => {
      try {

        const token = sessionStorage.getItem('authToken');
        const response = await fetch(`${process.env.REACT_APP_SERVER_UR}/delivery/partnerphoto`, {
          headers: {
            Authorization: `Bearer ${token!}`,
            // Add other headers if needed
          },
        });

        if (!response.ok) {
          throw new Error('Failed to fetch image');
        }

        const blob = await response.blob();
        const url = URL.createObjectURL(blob);
        setImageUrl(url);
      } catch (error) {
        console.error('Error fetching image stream:', error);
      }
    };

    fetchImage();

    return () => {
      if (imageUrl) {
        URL.revokeObjectURL(imageUrl);
      }
    };
  }, []);

  // Custom hook to calculate and update estimated time

  /*
    const useEstimatePickupTime = (pickupDate: Date, status: string) => {
      const [estimate, setEstimate] = useState("0 mins");
  
      useEffect(() => {
        // helper function
        const calculateEstimatePickupTime = (pickupDate: Date) => {
          const now = new Date();
          const pickup = new Date(pickupDate);
          const diffInMs = pickup.getTime() - now.getTime();
          const diffInMinutes = Math.round(diffInMs / 60000);
          return diffInMinutes > 0 ? `${diffInMinutes} mins` : "0 mins";
        };
  
        if (status === "accepted" || status === "pickedup") {
          // run immediately
          setEstimate(calculateEstimatePickupTime(pickupDate));
  
          // update every minute
          const interval = setInterval(() => {
            setEstimate(calculateEstimatePickupTime(pickupDate));
          }, 60 * 1000);
  
          // cleanup when status changes or component unmounts
          return () => clearInterval(interval);
        } else if (status === "waitingforpickup" || status === "delivered") {
          // stop updating, show final value
          setEstimate(calculateEstimatePickupTime(pickupDate));
        }
      }, [pickupDate, status]);
  
      return estimate;
    };
    */

  const onLocationUpdate = (topic: string, payload: any) => {

    var mqttPayload: {
      activityTime: string,
      activityType: string,
      data: {
        lat: number,
        lng: number,
      }
    } = JSON.parse(payload);

    var location = { lng: mqttPayload.data.lng, lat: mqttPayload.data.lat };

    const currentRoute = pathCoordinatesref.current;


    if (currentRoute && currentRoute.length > 0) {

      var locations = [...currentRoute!, location];
      setPathCoordinates(locations);
    }
    else {
      setPathCoordinates([location]);
    }

  }

  const getSheetHeaderConfig = (status: string) => {
    switch (status) {
      case "accepted":
        return { label: 'Delivery partner going to pickup parcel', nextStatus: "waitingforpickup" };
      case "waitingforpickup":
        return { label: 'Delivery partner is waiting for pickup order', nextStatus: "pickedup" };
      case "pickedup":
        return { label: 'Delivery partner Out for delivery', nextStatus: "delivered" };
      case "delivered":
        return { label: 'Delivery partner delivered the parcel', nextStatus: "delivered" };
      default:
        return { label: 'No Status' };
    }
  };
  /*
    const pickupEstimate = useEstimatePickupTime(
      currentService!.estimatedPickupTime!,
      currentService!.status
    );
  
    const deliveredEstimate = useEstimatePickupTime(
      currentService!.estimatedDeliveryTime!,
      currentService!.status
    );
    */


  const handleChange = (event: any) => {
    setSelectedOption(event.target.value);
  };

  const handleIsReportOpen = () => setIsReport(true);
  const handleIsReportClose = () => { setIsReport(false); setSelectedOption('') };

  const handleIsRatingsOpen = () => setIsRatings(true);
  const handleIsRatingsClose = () => setIsRatings(false);

  const handleRatingSubmit = () => {
    console.log("Submitted:", selectedOption);
    const reviewPayload: any = {
      reviewSummary: review,
      serviceRequest: currentService?.serviceRequestor?._id,
      deliveryPartner: currentService?.deliveryPartner?._id,
    }
    const reviewItemPayload: any = {
      reviewOn: 'Rate Delivery',
      reviewScore: rating,
    }

    const payloadData = {
      review: reviewPayload,
      reviewItem: reviewItemPayload
    }


    addReview(payloadData)
      .then((data) => {
        handleIsRatingsClose();
      })

  };

  const handleReportSubmit = () => {
    console.log("Submitted:", selectedOption);
    const payloadData = {
      reportedFromSource: 'DeliveryStatusApp',
      issueDescription: selectedOption,
      serviceRequest: currentService?._id,
      status: 'open',
      reportedBy: currentService?.destinationAddress?.mobileNumber,
    };
    addIssueReport(payloadData).then(() => {
      handleIsReportClose();

    })

  };

  function convertLocationToGeoRoute(locations: Location[]) {

    if (locations == null || locations.length == 0)
      return [];
    var path = locations.map(l => {
      return {
        lat: l.coordinates[1],
        lng: l.coordinates[0]
      }
    });
    setPathCoordinates(path);

  }

  if (currentService == null)
    return <div>Loading...</div>;


  return (

    <div style={{ display: "flex", flexDirection: "column", width: "100%", height: "100vh" }}>

      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={isError}
        onClose={() => { }}
        message="Something went wrong! Please try again..."
        key={"top" + "right"}
      />

      {/* Report POPUP */}
      <Modal
        open={isReport}
        onClose={handleIsReportClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={reportPopupStyle}>
          {/* Header with title + close button */}
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
            <Typography id="modal-modal-title" variant="h6" component="h2">
              Report your issue
            </Typography>
            <IconButton onClick={handleIsReportClose}>
              <img src={Close} alt="Phone" width={20} height={20} />
            </IconButton>
          </Box>

          {/* Options */}
          <RadioGroup value={selectedOption} onChange={handleChange}>
            <FormControlLabel value="delayed" control={<Radio />} label="Delayed the delivery" />
            <FormControlLabel value="damaged" control={<Radio />} label="The package has damaged" />
            <FormControlLabel value="changed" control={<Radio />} label="The parcel has changed" />
            <FormControlLabel value="others" control={<Radio />} label="Others" />
          </RadioGroup>

          {/* Submit button */}
          <Button
            variant="outlined" style={{
              borderColor: "#E1E1E1",
              color: "white",
              fontSize: 12,
              textTransform: "none",
              padding: "4px 10px",
              marginBottom: 15, borderRadius: 10,
              backgroundColor: selectedOption ? '#FA4A0C' : '#D9D9D9'
            }}


            fullWidth
            sx={{ mt: 2 }}
            onClick={handleReportSubmit}
            disabled={!selectedOption} // disabled until option selected
          >
            Submit
          </Button>
        </Box>
      </Modal>

      {/* Ratings POPUP */}

      <Modal open={isRatings} onClose={handleIsRatingsClose}>
        <Box sx={reportPopupStyle}>
          {/* Header */}
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 1 }}>
            <Typography variant="h6">Rating Parnter</Typography>
            <IconButton onClick={handleIsRatingsClose}>
              <img src={Close} alt="Phone" width={20} height={20} />
            </IconButton>
          </Box>

          {/* Star Rating */}
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: 'center' }}>

            <Rating
              name="half-rating"
              value={rating}
              style={{ fontSize: 30 }}
              onChange={(event, newValue) => {
                setRating(newValue);
              }}
              defaultValue={2.5} precision={0.5}
            />
          </Box>

          <p style={{ color: '#6B6E82', fontSize: 13 }}>Write Review (optional)</p>
          {/* Review Text */}
          <TextField
            fullWidth
            multiline
            rows={3}
            placeholder="Enter your comments..."
            variant="outlined"
            value={review}
            onChange={(e) => setReview(e.target.value)}
            sx={{ mb: 2 }}
          />

          {/* Submit Button */}

          <Button
            variant="outlined" style={{
              borderColor: "#E1E1E1",
              color: "white",
              fontSize: 12,
              textTransform: "none",
              padding: "4px 10px",
              marginBottom: 15, borderRadius: 10,
              backgroundColor: rating ? '#FA4A0C' : '#D9D9D9'
            }}


            fullWidth
            sx={{ mt: 2 }}
            disabled={!rating}
            onClick={handleRatingSubmit} // disabled until option selected
          >
            Submit
          </Button>

        </Box>
      </Modal>

      {/* Map area - 70% */}
      <div style={{ height: "75%" }}>
        {mapToken && <MapplsMap token={mapToken} hotelLocation={{ "lat": currentService?.serviceRequestor.company.location.coordinates[1], "lng": currentService?.serviceRequestor.company.location.coordinates[0] }}
          userLocation={{ "lat": currentService!.destinationAddress!.location.coordinates[1], "lng": currentService!.destinationAddress!.location.coordinates[0] }}
          pathCoordinates={pathCoordinates} style={{ width: "100%", height: "100%" }} />}
      </div>

      {/* Bottom Sheet - 30–35% */}

      {currentService && (
        <div
          style={{
            height: "35%",
            backgroundColor: "white",
            padding: "12px",
            boxShadow: "0 -2px 10px rgba(0,0,0,0.15)",
            display: "flex",
            flexDirection: "column",
            overflowY: "auto",
            // borderTopLeftRadius: 20,
            // borderTopRightRadius: 20,
            textAlign: "left",
            alignItems: "flex-start",
          }}
        >
          {/* Header */}
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: 8,
            }}
          >

            {currentService?.status == 'accepted' && (
              <TimeIntervalLabel textLabel={"pickup In"} dateTime={currentService?.estimatedPickupTime!} />
            )}

            {currentService?.status == 'pickedup' && (
              <TimeIntervalLabel textLabel={"Deliver In"} dateTime={currentService?.estimatedDeliveryTime!} />
            )}

            <Button variant="outlined" style={{
              borderColor: "#E1E1E1",
              color: "#FA4A0C",
              fontSize: 12,
              textTransform: "none",
              padding: "4px 10px",
              marginBottom: 15, borderRadius: 20
            }}
              onClick={() => handleIsReportOpen()}
              startIcon={<img src={RadioImage} alt="Phone" width={20} height={20} />}
            >
              Report
            </Button>

            {/* <p style={{ color: "#6B6E82", fontSize: 13, margin: '0px 0px 0px 0px' }}><img src={RadioImage} alt="Phone" width={13} height={13} style={{ margin: '0px 0px 1px 0px' }} />{' '}Report</p> */}
          </div>

          {/* Status */}
          <h3 style={{ margin: "0 0 6px", color: "black", fontSize: 14 }}>
            {getSheetHeaderConfig(currentService && currentService.status)?.label}
          </h3>

          {/* Order Id */}
          <h5 style={{ margin: "0 0 10px", fontSize: 12 }}>
            <span style={{ color: "#6B6E82" }}>Order Id : </span>
            <span style={{ color: "#FA4A0C" }}>{currentService.orderNumber}</span>
          </h5>

          {/* Restaurant */}
          <h4 style={{ margin: "0 0 12px", color: "black" }}>{currentService?.serviceRequestor.company.companyName}</h4>

          {/* Call Restaurant Button */}
          <Button variant="outlined" style={{
            borderColor: "#E1E1E1",
            color: "black",
            fontSize: 12,
            textTransform: "none",
            padding: "4px 10px",
            marginBottom: 15, borderRadius: 20
          }}
            onClick={() => {
              window.location.href = `tel:+91${currentService.serviceRequestor.mobileNumber}`; // replace with phone number
            }}
            startIcon={<img src={PhoneRingIcon} alt="Phone" width={20} height={20} />}
          >
            Call Restaurant
          </Button>

          {/* Delivery Partner */}
          <p style={{ margin: "0 0 10px", fontSize: 14, color: "black" }}>Delivery Partner</p>

          {/* Delivery Partner Card */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "95%",
              backgroundColor: "#fff",
              padding: "10px",
              borderRadius: 12,
              marginBottom: 10,
              boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
            }}
          >
            {/* Profile + Info */}
            <div style={{ display: "flex", alignItems: "center" }}>
              {/* Round Profile Image */}
              <div>
                {imageUrl ? (
                  <img src={imageUrl} alt="Streamed with auth" width={35} height={35} />
                ) : (
                  <p>Loading image...</p>
                )}
              </div>
              {/* Name + Verified */}
              <div style={{ display: "flex", flexDirection: "column" }}>
                <span style={{ fontSize: 14, fontWeight: "bold", color: "black" }}>
                  &nbsp;{currentService!.deliveryPartner!.partnerName}
                </span>
                {currentService!.deliveryPartner!.kycVerified == true && (
                  <span style={{ fontSize: 12, color: "#6B6E82" }}>
                    <span style={{ color: "green" }}>✔</span> ID Verified
                  </span>
                )}

              </div>
            </div>

            {/* Call Button */}
            <Button
              variant="outlined"
              style={{
                borderColor: "#FA4A0C",
                color: "white",
                fontSize: 13,
                textTransform: "none",
                padding: "4px 14px",
                backgroundColor: '#FA4A0C',
                fontWeight: 'bold',
                borderRadius: 20
              }}
              onClick={() => {
                window.location.href = `tel:+91${currentService?.deliveryPartner?.mobileNumber}`; // replace with phone number
              }}
              startIcon={<img src={WhiteLinePhone} alt="Phone" width={18} height={18} />}
            >
              Call
            </Button>

          </div>

          <Button variant="outlined" style={{
            borderColor: "#E1E1E1",
            color: currentService!.status == "delivered" ? "#FA4A0C" : "#B2B2B2",
            fontSize: 12,
            fontWeight: 'bold',
            textTransform: "none",
            padding: "4px 10px",
            marginBottom: 15, borderRadius: 20
          }}
            disabled={currentService.status == "delivered" ? false : true}
            onClick={() => handleIsRatingsOpen()}
            startIcon={<img src={currentService.status == "delivered" ? StarOrange : StarGray} alt="Phone" width={20} height={20} />}
          >
            Rate Delivery
          </Button>
        </div>
      )}

    </div>

  );
};

export default EndUserStatusScreen;
